import { formatNumber } from '@dmm/lib-common/lib/formatting';
import { MAX_AGE_TO_FINANCE, MIN_PRICE_TO_FINANCE } from '../../constants/BoatLoans';

export const calculateMonthlyPrice = (rate, term, loanAmount) => {
  if (!loanAmount || !term || !rate) {return;}

  let parsedRate = rate;
  let loanAmountAsNumber = loanAmount;

  if (typeof loanAmountAsNumber !== 'number') {
    loanAmountAsNumber = parseInt(loanAmount.replace(/[$,]/g, ''));

    if (!loanAmountAsNumber) {return;}
  }

  if (typeof parsedRate === 'string') {
    parsedRate = parseFloat(rate);
  }

  const ratePerMonth = parsedRate / 100 / 12;
  const x = Math.pow(1 + ratePerMonth, term);
  const monthlyPayment = Math.round((loanAmountAsNumber * ratePerMonth * x) / (x - 1), 2);
  return formatNumber(monthlyPayment);
};

export const isFinanceable = (price, boatYear) => {
  const boatAge = new Date().getFullYear() - (boatYear || 0);
  const boatPrice = price || 0;
  return boatPrice >= MIN_PRICE_TO_FINANCE && boatAge <= MAX_AGE_TO_FINANCE;
};
